import { Login } from '@/components';

const LoginRoute = () => <Login />;

export default LoginRoute;
